var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolhetos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.323,
    height: 34.74,
    viewBox: "0 0 32.323 34.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_289",
    "data-name": "Grupo 289",
    transform: "translate(-403.982 -672.572)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_003-brochure",
    "data-name": " 003-brochure",
    transform: "translate(403.982 672.572)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_227",
    "data-name": "Grupo 227"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_226",
    "data-name": "Grupo 226"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_722",
    "data-name": "Caminho 722",
    d: "M433.793,696.908H418.6a.509.509,0,0,0,0,1.019h15.2a.509.509,0,0,0,0-1.019Z",
    transform: "translate(-404.809 -673.999)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_723",
    "data-name": "Caminho 723",
    d: "M433.793,699.865H418.6a.509.509,0,0,0,0,1.018h15.2a.509.509,0,0,0,0-1.018Z",
    transform: "translate(-404.809 -674.172)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_724",
    "data-name": "Caminho 724",
    d: "M429.77,702.821H418.6a.509.509,0,1,0,0,1.018H429.77a.509.509,0,1,0,0-1.018Z",
    transform: "translate(-404.809 -674.346)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_725",
    "data-name": "Caminho 725",
    d: "M436.156,680.9l-4.169-4.169a.511.511,0,0,0-.361-.149H425.87V674.36a1.79,1.79,0,0,0-1.788-1.788H405.771a1.791,1.791,0,0,0-1.789,1.788v27.16a1.791,1.791,0,0,0,1.789,1.789h6.77a.509.509,0,0,0,0-1.019h-6.77a.77.77,0,0,1-.77-.77V674.36a.77.77,0,0,1,.77-.769h16.844l-6.651,2.552a2.425,2.425,0,0,0-1.524,1.94,3.5,3.5,0,0,0-.024.579h-7.3a.9.9,0,0,0-.9.9v4.56a.9.9,0,0,0,.9.9h7.3v1.367h-7.3a.9.9,0,0,0-.9.9v4.561a.9.9,0,0,0,.9.9h7.3v1.537h-7.691a.509.509,0,0,0,0,1.019h7.692v1.571h-7.691a.509.509,0,0,0,0,1.018h7.692v7.635a1.79,1.79,0,0,0,1.789,1.788h18.311a1.79,1.79,0,0,0,1.788-1.788V681.255a.51.51,0,0,0-.149-.36Zm-4.02-2.581,2.431,2.432h-1.66a.771.771,0,0,1-.77-.769Zm-14.463-1.737,7.014-2.691a.765.765,0,0,1,.164.474v2.217ZM407.235,684V679.68h7.182V684Zm0,7.725v-4.322h7.182v4.322Zm27.282,14.568H416.2a.77.77,0,0,1-.769-.77V678.366a.77.77,0,0,1,.769-.769h14.914v2.38a1.79,1.79,0,0,0,1.788,1.788h2.381v23.761a.771.771,0,0,1-.769.77Z",
    transform: "translate(-403.982 -672.572)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_726",
    "data-name": "Caminho 726",
    d: "M433.21,684.021H423.153a.509.509,0,1,0,0,1.018H433.21a.14.14,0,0,1,.139.138v6.882l-2.586-3.115a1.432,1.432,0,0,0-2.016-.186,1.465,1.465,0,0,0-.186.186l-1.11,1.338-2.371-2.857a1.43,1.43,0,0,0-2.015-.186,1.452,1.452,0,0,0-.186.186l-3.863,4.655v-6.9a.139.139,0,0,1,.138-.138h1.618a.509.509,0,0,0,0-1.018h-1.618A1.158,1.158,0,0,0,418,685.178v7.294a1.158,1.158,0,0,0,1.157,1.156h14.056a1.156,1.156,0,0,0,1.156-1.156v-7.294A1.157,1.157,0,0,0,433.21,684.021Zm-3.865,5.574a.413.413,0,0,1,.581-.055.493.493,0,0,1,.055.055l2.5,3.015h-5.639Zm-5.682-1.519a.412.412,0,0,1,.58-.055.424.424,0,0,1,.055.055l2.493,3-1.27,1.53H419.9Z",
    transform: "translate(-404.804 -673.243)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolhetos);
export default __webpack_public_path__ + "static/media/folhetos.ddf5dfc6920a88f69a3180fc02dedef6.svg";
export { ForwardRef as ReactComponent };